<span
  class="avatar-initial"
  [ngClass]="[colorClass, sizeClass, customClass]"
  [attr.aria-label]="name">
  {{ initial }}
</span>
